import { t } from '@lingui/core/macro';
import { Mounting, PackageMountingEnum } from '@luminovo/api-contracts';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';
import type { JSX } from 'react';

const options: Mounting[] = [
    { name: PackageMountingEnum.SMT },
    { name: PackageMountingEnum.THT },
    { name: PackageMountingEnum.PressFit },
    { name: PackageMountingEnum.Other },
];

export function FieldMounting({
    onChange,
    ...props
}: Omit<FieldSelectProps<Mounting>, 'options' | 'onChange'> & { onChange: (mounting: Mounting) => void }): JSX.Element {
    return (
        <FieldSelect
            options={options}
            disableClearable
            getOptionLabel={(option) => option.name}
            placeholder={t`Mounting`}
            onChange={(value) => {
                // Default to SMT if no value is selected
                onChange(value ?? options[0]);
            }}
            {...props}
        />
    );
}
